import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addPackagetreatment,
  getPackagetreatments,
  getPackagetreatment,
  editPackagetreatment,
  deletePackagetreatment,
  getAllPackagetreatments,
} from '../../store/actions/packagetreatment_action';
import _debounce from 'lodash/debounce';
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllPackagetreatments = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.packagetreatment);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deletePackagetreatment(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getPackagetreatments({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSinglePackagetreatment = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.packagetreatment);
  useEffect(() => {
    dispatch(getPackagetreatment(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreatePackagetreatment = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.packagetreatment);
  const addData = async (data) => {
    await dispatch(addPackagetreatment(data));
  };
  return [data, addData];
};
export const useUpdatePackagetreatment = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.packagetreatment);
  const updateData = async (id, data) => {
    console.log('datatatatatatat', data);
    await dispatch(editPackagetreatment(id, data));
  };
  return [updateData];
};

export const useSelectAllPackagetreatment = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState('');
  const [value, setValue] = useState('');
  const data = useSelector((state) => state.packagetreatment);
  useEffect(() => {
    dispatch(getAllPackagetreatments({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "parent_category") {
    //   await setCategorySearchField("name");
    //   await setCategorySearchValue(inputValue);
    //   callback(dropdownOptions.parent_category);
    // }
  };

  return [dropdownOptions, loadOptions];
};
